<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" v-if="input">
      <router-link :to="{ name: 'Estimate', params: { car:this.$route.params.car, nativeData:this.$route.params.nativeData, tsId:this.$route.params.tsId, ssInfo:this.$route.params.ssInfo, profileInfo:this.$route.params.profileInfo }}">
        <button id="isInput" class="button fs16 mb20 pd16 w80p" style="display: none;"></button>
      </router-link>
      <PreferredDateInput
      v-bind:inspection="inspection"
      v-bind:ssInfo="ssInfo"
      @toConfirmCheck="toConfirmCheck"></PreferredDateInput>
    </div>
    <div v-if="confirm">
      <a id="isConfirm"></a>
      <PreferredDateConfirm
      @backToInput="backToInput"
      @toCompleteCheck="toCompleteCheck"
      v-bind:inspection="inspection"
      v-bind:car="$route.params.car"
      v-bind:price="$route.params.price"
      v-bind:expiryOnWareki="$route.params.expiryOnWareki"
      v-bind:firstRegistrationOnWareki="$route.params.firstRegistrationOnWareki"
      v-bind:Manufacturer="$route.params.Manufacturer"
      v-bind:carType="$route.params.carType"
      v-bind:processing="processing"
      v-bind:ssInfo="ssInfo"></PreferredDateConfirm>
    </div>
    <div v-if="complete">
      <PreferredDateComplete
      v-bind:ssInfo="ssInfo"
      v-bind:nativeData="$route.params.nativeData"></PreferredDateComplete>
    </div>
  </div>
</template>
<script>

import inspectionApi from '@/store/Api/inspection'
import PreferredDateInput from '@/views/PreferredDateInput.vue'
import PreferredDateConfirm from '@/views/PreferredDateConfirm.vue'
import PreferredDateComplete from '@/views/PreferredDateComplete.vue'
import ssApi from '@/store/Api/Common/ss'
import Loading from '@/views/Loading.vue'
import modal from '../assets/modal'
import emoji from 'emoji-regex'

export default {
  data: () => ({
    inspection: {
      tel: '',
      user_request: '',
      replacement_vehicle_requested: 'false'
    },
    agreement: {
      matter1: false,
      matter2: false,
      matter3: false,
      matter4: false,
      matter5: false
    },
    post: {
      ts_id: '',
      tel: '',
      user_request: '',
      replacement_vehicle_requested: '',
      estimate_price: '',
      estimate: {},
      price: {}
    },
    loading: true,
    input: true,
    confirm: false,
    complete: false,
    ssInfo: [],
    isSuccses: true,
    processing: false
  }),
  components: {
    PreferredDateInput,
    PreferredDateConfirm,
    PreferredDateComplete,
    Loading
  },
  methods: {
    // 入力 → 確認画面遷移バリデーション
    async toConfirmCheck (inspection, form) {
      this.isSuccses = true
      // トラッキング処理
      this.nativeEVENTSet('ShakenKiboubiButton', 'MOVED_YOYAKU_KAKUNIN', 'TAP')
      // 市外局番ありパターン
      /* eslint-disable-next-line prefer-regex-literals */
      const landLineRegex = new RegExp(/^0(\d{1}[-(]?\d{4}|\d{2}[-(]?\d{3}|\d{3}[-(]?\d{2}|\d{4}[-(]?\d{1})[-)]?\d{4}$/)
      // 携帯電話パターン
      /* eslint-disable-next-line prefer-regex-literals */
      const mobileRegex = new RegExp(/^0[5789]0[-(]?\d{4}[-)]?\d{4}$/)

      // 連絡先電話番号
      if (!landLineRegex.test(inspection.tel) && !mobileRegex.test(inspection.tel)) {
        form.telErrorMessage = '電話番号の形式に誤りがあります。'
        this.isSuccses = false
      } else {
        // 電話番号が正しい場合はハイフンを除去
        this.inspection.tel = this.inspection.tel.replace(/-/g, '')
      }

      // 連絡希望時間帯
      if (inspection.user_request.length >= 101) {
        form.userRequestErrorMessage = '連絡希望時間帯は100文字以内で入力してください。'
        this.isSuccses = false
      }
      // 連絡希望時間帯 絵文字チェック
      const match = emoji().exec(inspection.user_request)
      if (match) {
        form.userRequestErrorMessage = '連絡希望時間帯に絵文字は入力できません。'
        this.isSuccses = false
      }

      if (this.isSuccses) {
        this.inspection = inspection
        this.input = false
        this.confirm = true
        window.scroll(0, 0)
      } else {
        let scrollId = ''
        if (form.telErrorMessage !== '') {
          scrollId = '#tel'
        } else if (form.userRequestErrorMessage !== '') {
          scrollId = '#userRequest'
        }
        this.$SmoothScroll(
          document.querySelector(scrollId),
          500,
          null,
          null,
          'y'
        )
      }
    },
    // 確認 → 完了画面遷移バリデーション
    async toCompleteCheck (agreement, form) {
      this.isSuccses = true
      // トラッキング処理
      this.nativeEVENTSet('ShakenKakuninButton', 'MOVED_SHAKEN_MOSIKOMI', 'TAP')
      if (agreement.matter1 && agreement.matter2 && agreement.matter3 && agreement.matter4 && agreement.matter5) {
        // 二度押しを防ぐ為、ロック開始
        this.processing = true
        // POST送信するためにデータを整形する
        /* eslint-disable no-multi-spaces */
        this.post.ts_id                                     = this.$route.params.car.ts_id
        this.post.tel                                       = this.inspection.tel
        this.post.user_request                              = this.inspection.user_request
        this.post.replacement_vehicle_requested             = (this.inspection.replacement_vehicle_requested === 'true')
        this.post.estimate_price                            = this.$route.params.price.total
        this.post.ss_name                                   = this.ssInfo.ss_name
        this.post.mail_address_1                            = this.ssInfo.mail_address_1
        this.post.mail_address_2                            = this.ssInfo.mail_address_2
        this.post.mail_address_3                            = this.ssInfo.mail_address_3
        this.post.mail_address_4                            = this.ssInfo.mail_address_4
        this.post.mail_address_5                            = this.ssInfo.mail_address_5
        this.post.estimate.ts_id                            = this.$route.params.car.ts_id
        this.post.estimate.popinfo_id                       = this.$route.params.nativeData.popinfoid
        this.post.estimate.prefecture_name                  = this.ssInfo.prefecture
        this.post.estimate.coupon_id                        = this.$route.params.car.coupon_id
        this.post.estimate.cars_id                          = this.$route.params.car.id
        this.post.estimate.ss_code                          = this.$route.params.car.bestmy_ss_id
        this.post.estimate.ss_factory_type_code             = this.ssInfo.factory_type_flag
        this.post.estimate.mileage                          = this.$route.params.car.mileage
        this.post.estimate.weight                           = this.$route.params.car.weight
        this.post.estimate.model_code                       = this.$route.params.car.model_code
        this.post.estimate.plate_number                     = this.$route.params.car.plate_number
        this.post.estimate.first_registration_on            = this.$route.params.car.first_registration_on
        this.post.estimate.manufacturer_id                  = this.$route.params.car.manufacturer_id
        this.post.estimate.expiry_on                        = this.$route.params.car.expiry_on
        this.post.estimate.oil_exchanged                    = this.$route.params.car.oil_exchanged
        this.post.estimate.tax                              = this.taxRate()
        this.post.price.cali_fee                            = this.$route.params.price.legal_fee.cali_fee
        this.post.price.weight_tax                          = this.$route.params.price.legal_fee.weight_tax
        this.post.price.revenue_stamp_fee                   = this.$route.params.price.legal_fee.revenue_stamp_fee
        this.post.price.base_price                          = this.$route.params.price.price.base_price
        this.post.price.oil_exchanged_fee                   = this.$route.params.price.price.oil_exchanged_fee
        this.post.price.coupon_fee                          = this.$route.params.price.coupon_fee
        /* eslint-enable no-multi-spaces */
        // POST送信
        this.inspectionApiPost(this.post)
        // 二度押しロック解除
        // this.processing = false
      } else {
        form.agreementErrorMessage = '確認・同意項目すべてにチェックを入れてください。'
      }
    },
    // 車検テーブルのPOST実行
    async inspectionApiPost (post) {
      await inspectionApi.post(post).then(res => {
        if (this.isSuccses) {
          window.scroll(0, 0)
          this.confirm = false
          this.complete = true
          // 二度押しロック解除
          this.processing = false
        }
      }).catch(e => {
        this.openErrorModal('エラーが発生しました。')
        // 二度押しロック解除
        this.processing = false
      })
    },
    // 入力画面へ戻る
    async backToInput (inspection) {
      window.scrollTo(0, 0)
      this.inspection = inspection
      this.input = true
      this.confirm = false
      this.complete = false
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  async mounted () {
    let isApiError = false
    // SS情報マスタ取得
    await ssApi.get(this.$route.params.car.bestmy_ss_id).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    if (!isApiError) {
      this.loading = false
    }
  }
}
</script>
